module.exports = __webpack_public_path__ + "static/media/covi_can_cle.4268cff0.png";